import { useState, useCallback } from 'react';

/**
 * Custom hook for managing horse data in localStorage
 */
export const useHorseStorage = () => {
  const STORAGE_KEY = 'localHorses';

  const getLocalHorses = useCallback(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch (error) {
      console.error('Error reading from localStorage:', error);
      return [];
    }
  }, []);

  const saveLocalHorse = useCallback((horse) => {
    try {
      const existingHorses = getLocalHorses();
      const updatedHorses = [...existingHorses, horse];
      localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedHorses));
      return true;
    } catch (error) {
      console.error('Error saving to localStorage:', error);
      return false;
    }
  }, [getLocalHorses]);

  const updateLocalHorse = useCallback((horseId, updates) => {
    try {
      const existingHorses = getLocalHorses();
      const updatedHorses = existingHorses.map(h =>
        h.id === horseId ? { ...h, ...updates } : h
      );
      localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedHorses));
      return true;
    } catch (error) {
      console.error('Error updating localStorage:', error);
      return false;
    }
  }, [getLocalHorses]);

  const deleteLocalHorse = useCallback((horseId) => {
    try {
      const existingHorses = getLocalHorses();
      const updatedHorses = existingHorses.filter(h => h.id !== horseId);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedHorses));
      return true;
    } catch (error) {
      console.error('Error deleting from localStorage:', error);
      return false;
    }
  }, [getLocalHorses]);

  const clearLocalHorses = useCallback(() => {
    try {
      localStorage.removeItem(STORAGE_KEY);
      return true;
    } catch (error) {
      console.error('Error clearing localStorage:', error);
      return false;
    }
  }, []);

  return {
    getLocalHorses,
    saveLocalHorse,
    updateLocalHorse,
    deleteLocalHorse,
    clearLocalHorses
  };
};
